import {
  SchedulingSettings,
  createDefaultSchedulingSettings,
} from "@/data/models/SchedulingSettings";
import { getClientRef } from "@/data/repository/ClientRepository";
import { db } from "@/main";

function getSchedulingSettingsRef() {
  return db
    .doc(getClientRef())
    .collection("settings")
    .doc("schedulingSettings");
}

export async function saveSchedulingSettings(
  schedulingSettings: SchedulingSettings
) {
  return getSchedulingSettingsRef().set(schedulingSettings, {});
}

export async function loadSchedulingSettings() {
  const snapshot = await getSchedulingSettingsRef().get();

  if (!snapshot.exists) {
    return createDefaultSchedulingSettings();
  }

  const settings = snapshot.data() as SchedulingSettings;

  return {
    ...createDefaultSchedulingSettings(),
    ...settings,
  };
}
